import React, { createContext, useContext, useState, ReactNode } from 'react';

interface FilteredKeywordsContextType {
  filteredMissingKeywords: string[];
  filteredPresentKeywords: string[];
  setFilteredKeywords: (missing: string[], present: string[]) => void;
}

const FilteredKeywordsContext = createContext<FilteredKeywordsContextType | undefined>(undefined);

export function FilteredKeywordsProvider({ children }: { children: ReactNode }) {
  const [filteredMissingKeywords, setFilteredMissingKeywords] = useState<string[]>([]);
  const [filteredPresentKeywords, setFilteredPresentKeywords] = useState<string[]>([]);

  const setFilteredKeywords = (missing: string[], present: string[]) => {
    setFilteredMissingKeywords(missing);
    setFilteredPresentKeywords(present);
  };

  return (
    <FilteredKeywordsContext.Provider value={{
      filteredMissingKeywords,
      filteredPresentKeywords,
      setFilteredKeywords
    }}>
      {children}
    </FilteredKeywordsContext.Provider>
  );
}

export function useFilteredKeywords() {
  const context = useContext(FilteredKeywordsContext);
  if (context === undefined) {
    throw new Error('useFilteredKeywords must be used within a FilteredKeywordsProvider');
  }
  return context;
}
